import React from 'react';
import { useRouter } from 'next/router';
import { useState, useEffect } from 'react';
import Link from 'next/link';
import { Container } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { HereToHelpStyled } from './HereToHelpStyled';
import { ButtonBase } from '../Forms';
import { dataLayerSendEvent } from '@common/Utility/analytics-utils';
import { useFlags } from '@common/Lib/Flagsmith';
import { useNavigationURL } from '@common/Utility/generateNavigationURL';
import { useTranslation } from '@common/i18n';

const HereToHelp = (props) => {
  const [isClient, setIsClient] = useState(false);
  const flags = useFlags(['help_text']);
  const router = useRouter();
  const generateURL = useNavigationURL();
  const t = useTranslation();

  useEffect(() => {
    setIsClient(true);
  }, []);

  if (!isClient) return null;
  return (
    <HereToHelpStyled className={`bg-white ${props?.customClass}`}>
      <Container>
        <div className="text">{t('Footer.txtHereToHelp')}</div>
        <Link href={generateURL("/faq/[id]")} as={generateURL("/faq/generic")} passHref>
          <a>
            <ButtonBase
              data-test="button"
              minWidth="170px"
              size="sm"
              variant="primary mobile-btn-margin"
              text={t('Footer.btnHelpCenter')}
              onClick={() => {
                router.push({ pathname: generateURL(`/faq/[id]`), query: { id: 'generic' } });
                dataLayerSendEvent('help_center_click', {
                  screen_name: props?.screenName,
                });
              }}
            />
          </a>
        </Link>
      </Container>
    </HereToHelpStyled>
  );
};

HereToHelp.propTypes = {
  screenName: PropTypes.string,
  customClass: PropTypes.string,
};

HereToHelp.defaultProps = {
  screenName: 'Homepage - Aster Core',
  customClass: '',
};
export default HereToHelp;
